<div class="ui-grid" *ngIf="feedback">
  <div class="ui-g feedbackHeader">
    <div
      class="ui-g-12 ui-md-1 statusColor"
      [ngClass]="{
        orange: feedback.resolvedTimeStamp == null,
        green: feedback.resolvedTimeStamp != null
      }"
    ></div>
    <div class="ui-g-12 ui-md-11 ui-g-nopad">
      <div class="ui-g-12 feedbackHeadTextMain">
        Supplier Feedback {{ feedback.resolvedTimeStamp == null ? '(Open)' : '' }}
      </div>
      <div class="ui-g-12 feedbackHeadTextSub">
        Raised by: {{ feedback.raisedByUserName }} on
        {{ feedback.createdOn | date : 'dd/MM/yyyy HH:mm' }}
      </div>
      <div *ngIf="feedback.resolvedTimeStamp != null" class="ui-g-12 feedbackHeadTextOutcome">
        Resolved on {{ feedback.resolvedTimeStamp | date : 'dd/MM/yyyy HH:mm' }} by
        {{ feedback.resolvedByUserName }} - [{{ feedback.outcomeDescription }}]
      </div>
    </div>
  </div>

  <div class="ui-g-12">
    <div class="ui-g-12 ui-md-2">
      <strong>Job Number</strong>
    </div>
    <div class="ui-g-12 ui-md-4">
      <span class="badge">{{ feedback.jobNumber }}</span>
    </div>

    <div class="ui-g-12 ui-md-2">
      <strong>Customer</strong>
    </div>
    <div class="ui-g-12 ui-md-4">
      {{ feedback.customerName }}
    </div>

    <div class="ui-g-12 ui-md-2">
      <strong>Task</strong>
    </div>
    <div class="ui-g-12 ui-md-4">
      {{ feedback.taskKey }}
    </div>

    <div class="ui-g-12 ui-md-2">
      <strong>Supplier</strong>
    </div>
    <div class="ui-g-12 ui-md-4">
      {{ feedback.supplierName }}
    </div>
    <div class="ui-g-12 ui-md-2">
      <strong>Last Updated</strong>
    </div>
    <div class="ui-g-12 ui-md-4">
      {{ feedback.lastUpdated | date : 'dd/MM/yyyy HH:mm' }}
    </div>

    <div class="ui-g-12 ui-md-2">
      <strong>Feedback:</strong>
    </div>
    <div id="FeedbackType" class="ui-g-12 ui-md-4 spacer">
      {{ feedback.supplierFeedbackType.description }}
    </div>

    <div class="ui-g-12 feedbackOutcomeHeader">
      <div class="ui-g-3 dropdownLabel">Outcome (resolution)</div>
      <div class="ui-g-9">
        <p-dropdown
          [options]="outcomes"
          class="dropdown"
          placeholder="Select Outcome"
          [(ngModel)]="selectedOutcome"
          [disabled]="loadOutcomesError || notFound || feedback.resolvedTimeStamp != null"
        >
        </p-dropdown>
        <button
          type="button"
          pButton
          label="Resolve Feedback"
          class="ui-button green-btn btn-to-right"
          (click)="onResolveFeedback()"
          [disabled]="
            loadOutcomesError || notFound || feedback.resolvedTimeStamp != null || !selectedOutcome
          "
        ></button>
        <!--<div class="ui-error" *ngIf="messageControl.invalid && (messageControl.dirty || messageControl.touched)">Select an outcome to resolve the feedback record</div>-->
      </div>
    </div>

    <div class="ui-g-12 ui-md-12 subHeader">
      <strong>History</strong>
    </div>

    <hr />

    <ng-template ngFor let-fh [ngForOf]="feedback.feedbackHistories" let-i="index">
      <div class="ui-g-12 ui-md-12 ui-g-nopad ui-card">
        <div class="ui-g-12 ui-md-2">
          <strong>Date Added</strong>
        </div>
        <div class="ui-g-12 ui-md-4">
          {{ fh.timeStamp | date : 'dd/MM/yyyy HH:mm' }}
        </div>
        <div class="ui-g-12 ui-md-2">
          <strong>Added By</strong>
        </div>
        <div class="ui-g-12 ui-md-4">
          {{ fh.userName }}
        </div>
        <div id="TextDescription" class="ui-g-12 ui-md-12">
          {{ fh.text }}
        </div>
      </div>
    </ng-template>

    <form
      [formGroup]="newMessageform"
      #addFeedbackDetailForm="ngForm"
      id="add-details-form"
      class="ui-g-12 ui-md-12 ui-g-nopad"
      (ngSubmit)="onSubmit()"
      *ngIf="feedback.resolvedTimeStamp == null"
    >
      <div class="ui-g-12 ui-md-10">
        <textarea
          [(ngModel)]="saveFeedbackDetails.text"
          class="ui-inputtextarea"
          pInputTextarea
          name="newMessage"
          [formControl]="messageControl"
          [maxlength]="3072"
          required
          placeholder="Add new text"
        ></textarea>
        <div
          class="ui-error"
          *ngIf="messageControl.invalid && (messageControl.dirty || messageControl.touched)"
        >
          The message field cannot be empty
        </div>
      </div>
      <div class="ui-g-12 ui-md-2" style="min-width: 100px">
        <div class="ui-grid">
          <div class="ui-grid-row">
            <button
              type="button"
              pButton
              label="Save Message"
              class="ui-button green-btn btn-to-right"
              (click)="onSubmit()"
            ></button>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="ui-g-12 ui-md-12">
    <button type="button" (click)="back()" pButton label="Back"></button>
  </div>
</div>
<div *ngIf="isLoading">Loading...</div>
<div *ngIf="notFound">Supplier Feedback not found.</div>
<p-confirmDialog
  header="Confirmation"
  icon="fa-icon-circle"
  [style]="{ width: '425px' }"
  acceptLabel="Save"
  rejectLabel="Cancel"
></p-confirmDialog>
